import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Session lives in an httpOnly cookie set by the backend; nothing is stored in localStorage.
export const api = axios.create({ baseURL: API, withCredentials: true });

export function apiErrorMessage(e, fallback = "Something went wrong. Please try again.") {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  if (detail?.msg) return detail.msg;
  return e?.message || fallback;
}

// Authenticated file download (cookie-based) that saves the response as a file.
export async function downloadBlob(path, filename, { method = "GET", data } = {}) {
  const r = await api.request({ url: path, method, data, responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url; a.download = filename; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}
